import { computed, inject } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap, tap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';

import { CheckService } from '../../../../core/checks/check';
import { CheckStageDTO, CheckStatus } from '../../../../core/models/checks-model';
import { PendingCheckContextStore } from './pending-check-context.store'; // <-- Wichtig!

type StageState = {
  stages: CheckStageDTO[];
  isLoading: boolean;
  error: string | null;
};

const initialState: StageState = {
  stages: [],
  isLoading: false,
  error: null,
};

export const PendingCheckStageStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),

  withComputed((
    store,
    contextStore = inject(PendingCheckContextStore)
  ) => ({

    activeStageId: computed<number | null>(() => {
      const check = contextStore.currentCheck();
      const stages = store.stages();

      if (!check || stages.length === 0) return null;

      let targetPhase: string;
      switch (check.status) {
        case CheckStatus['Kontrolle 1-1']: targetPhase = 'FIRST';  break;
        case CheckStatus['Kontrolle 1-2']: targetPhase = 'SECOND'; break;
        case CheckStatus['Kontrolle 2']:   targetPhase = 'REVIEW'; break;
        default: return null;
      }
      return stages.find(s => s.phase === targetPhase)?.id ?? null;
    })
  })),

  // 2. Methoden & API-Calls
  withMethods((
    store,
    checkService = inject(CheckService)
  ) => ({

    loadStagesByCheckId: rxMethod<string | null>(
      pipe(
        tap(() => patchState(store, { isLoading: true, error: null })),
        switchMap((checkId) => {
          if (!checkId) {
            patchState(store, { stages: [], isLoading: false });
            return [];
          }

          return checkService.fetchCheckStagesApi(checkId).pipe(
            tapResponse({
              next: (stages) => patchState(store, { stages, isLoading: false }),
              error: (err: any) => {
                patchState(store, { error: err.message, isLoading: false });
                console.error('Fehler beim Laden der Stages:', err);
              }
            })
          );
        })
      )
    )
  }))
);
